import React from "react";
import { GlobalStyle, ThemeProvider } from "@react95/core";
import { createGlobalStyle } from "styled-components";
import DataService from "../services/dataService";
import DataContext from "../contexts/dataContext";
import Taskbar from "./Taskbar";
import Desktop from "./Desktop";

const dataService = new DataService();

const BodyFontSizeOverride = createGlobalStyle`
  body{
    font-size: 15px
  }

  a:link,
  a:visited {
    color: #010f7a;
  }
  
  /* Fix for title bar text with descenders (j, p, g, y) bleeding into content */
  [class*="TitleBar__TitleBarBackground"] {
    overflow: visible !important;
    height: auto !important;
    min-height: 18px !important;
    padding-bottom: 3px !important;
  }
  
  [class*="TitleBar__Title"] {
    line-height: 1.2 !important;
    overflow: visible !important;
  }
`;

const App = () => (
  <DataContext.Provider value={dataService}>
    <ThemeProvider>
      <GlobalStyle />
      <BodyFontSizeOverride />

      <Desktop />
      <Taskbar />
    </ThemeProvider>
  </DataContext.Provider>
);
export default App;
